const removeHTMLTags = (value) =>
  value
    .replace(/<[^>]*>/gi, ' ')
    .replace(/<\/[^>]*>/gi, ' ')
    .replace(/&nbsp;|&#160;/gi, ' ')
    .replace(/\s+/gi, ' ')
    .trim()

export default removeHTMLTags
